import { render, staticRenderFns } from "./LabelShop.vue?vue&type=template&id=a788b842"
import script from "./LabelShop.vue?vue&type=script&lang=js"
export * from "./LabelShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports